import { motion } from "framer-motion";
import { Facebook, Instagram, Linkedin, Github, Twitter, X } from "lucide-react";

const socialPlatforms = [
  { key: "facebook", icon: Facebook },
  { key: "twitter", icon: Twitter },
  { key: "instagram", icon: Instagram },
  { key: "linkedin", icon: Linkedin },
  { key: "github", icon: Github },
];

const ExpandedCard = ({ member, onClose }) => {
  const { name, role, image, description, socialLinks } = member;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const availableLinks = socialPlatforms.filter(
    (platform) => socialLinks && socialLinks[platform.key]
  );

  return (
    <motion.div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={handleOverlayClick}
    >
      <motion.div
        className="bg-white rounded-3xl p-8 md:p-10 max-w-lg w-full max-h-[90vh] overflow-y-auto shadow-2xl relative"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-[#6b7280] hover:text-[#3a3a3a] transition-colors"
          aria-label="Close"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="flex flex-col items-center text-center">
          <div className="w-32 h-32 rounded-full border-4 border-[#6B8F8A] overflow-hidden mb-4">
            <img 
              src={image} 
              alt={name} 
              className="w-full h-full object-cover"
            />
          </div>

          <h3 className="text-2xl font-bold text-[#6B8F8A] mb-2">{name}</h3>
          <p className="text-[#6b7280] font-medium mb-4">{role}</p>
          <p className="text-[#6b7280] leading-relaxed mb-6">{description}</p>

          {availableLinks.length > 0 && (
            <div className="flex items-center gap-4">
              {availableLinks.map(({ key, icon: Icon }) => (
                <a
                  key={key}
                  href={socialLinks[key]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-[#6B8F8A]/10 flex items-center justify-center text-[#6B8F8A] hover:bg-[#6B8F8A] hover:text-white transition-all duration-200"
                  aria-label={key}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          )}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ExpandedCard;
